import { gql } from '@apollo/client';
import { ACFMediaFragment } from "@/fragments";
import { DetailHeroFragment } from './DetailHero';
import { PageDataFragment } from './PageData';

export const EventFragment = gql`
  ${ACFMediaFragment}
  ${PageDataFragment}
  fragment EventFragment on Event {
    databaseId
    uri
    title
    ...PageData
    eventTypes {
      nodes {
        name
        slug
      }
    }
    featuredEventImage {
      ...ACFMedia
    }
    eventData {
      eventDescription
      ticketLink
      customCursorText
      startDate
      endDate
      pricingType
      price {
        gaPrice
        membersPrice
        priceWithAdmission
      }
      performers {
        performerName
      }
    }
  }
`;

export const EventDetailFragment = gql`
  ${EventFragment}
  ${DetailHeroFragment}
  fragment EventDetailFragment on Event {
    ...EventFragment
    detailHero {
      ...DetailHero
    }
  }
`;
